<template>
  <li>
    <div class="order-info">
      <span
        v-if="item.statCd == 'C'"
        class="c-util-button type-line-primary type-small type-round"
      >
        <span class="bold">배송완료</span>
      </span>
      <span
        v-if="item.statCd == 'C2'"
        class="c-util-button type-line-primary type-small type-round"
      >
        <span class="bold">주문취소</span>
      </span>
      <ul class="list">
        <li class="item">
          <strong> 주문일자 : </strong>
          <span> {{ item.erdDat }}</span>
        </li>
        <li class="item">
          <strong> 페인트 프로 주문번호 : </strong>
          <span> {{ item.orderNo }} </span>
        </li>
        <li class="item" v-if="item.statCd != '0'">
          <strong> SAP 주문번호 : </strong>
          <span> {{ item.sapOrderNo }} </span>
        </li>
      </ul>
    </div>
    <div class="info-detail">
      <div
        v-if="item.statCd != 'C' && item.statCd != 'C2'"
        class="address-info"
      >
        <span class="c-round-flag type-gray">배송지</span>
        <p class="text">배송방법 : {{ item.dlvMthdNm }}</p>
        <p class="text">
          <template
            v-if="
              item.dlvMthdCd == 10 ||
              item.dlvMthdCd == 15 ||
              item.dlvMthdCd == 18 ||
              item.dlvMthdCd == 25
            "
          >
            {{ item.addr }}
          </template>
          <template v-if="item.dlvMthdCd == 20">
            {{ item.dlvBranchCd }}
          </template>
          <template v-if="item.dlvMthdCd == 30">
            {{ Utils.replace(item.werks, "노루페인트", "") }}
          </template>
        </p>
      </div>
      <div class="product-info">
        <template v-if="item.statCd == 0 || item.statCd == 'C2'">
          <p>
            {{ item.posnr1 }}
          </p>
        </template>
        <template
          v-if="
            item.statCd == 1 ||
            item.statCd == 'A' ||
            item.statCd == 'B' ||
            item.statCd == 'C'
          "
        >
          <p>
            {{ item.posnr2 }}
          </p>
        </template>
      </div>
      <div class="price-info">
        <div class="price-info-item">
          <strong>주문금액</strong>
          <span>{{ Number(item.goodsPrc).toLocaleString() }}원</span>
        </div>
      </div>
    </div>
    <div v-if="item.statCd != 'C' && item.statCd != 'C2'" class="status-info">
      <div class="c-process-state">
        <ol>
          <li
            :class="{ 'is-current': item.statCd == '0' }"
            :aria-current="item.statCd == '0' ? 'step' : null"
          >
            <span class="step-circle"></span>
            <span class="text">주문대기</span>
          </li>
          <li
            :class="{ 'is-current': item.statCd == '1' }"
            :aria-current="item.statCd == '1' ? 'step' : null"
          >
            <span class="step-circle"></span>
            <span class="text">주문접수</span>
          </li>
          <li
            :class="{ 'is-current': item.statCd == 'A' }"
            :aria-current="item.statCd == 'A' ? 'step' : null"
          >
            <span class="step-circle"></span>
            <span class="text">제품준비</span>
          </li>
          <li
            :class="{ 'is-current': item.statCd == 'B' }"
            :aria-current="item.statCd == 'B' ? 'step' : null"
          >
            <span class="step-circle"></span>
            <span class="text">배송중</span>
          </li>
        </ol>
      </div>
    </div>
  </li>
</template>
<script setup>
import { ref, defineProps } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const item = ref(props.item);
</script>
